import {
  dateFormatter, dateTimeFormatter,
  getLegalEntityName, localeFormatter, smevCheckWithContentFormatter, statusFormatter, userPositionFormatter,
} from '../../../utils/formatters';

export const applicationColumns = [
  {
    dataField: 'created_at',
    text: 'Дата создания',
    headerClassName: 'created-at',
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'applicant',
    text: 'Заявитель',
    headerClassName: 'user-column',
    formatter: getLegalEntityName,
  },
  {
    dataField: 'mais_egu_id',
    text: 'Номер обращения',
    headerClassName: 'number-column',
    formatter: (id, item) => smevCheckWithContentFormatter(id || 'Номер не указан', item?.checks_status || ''),
  },
  {
    dataField: 'apply_method',
    text: 'Способ подачи',
    headerClassName: 'apply-method-column',
    formatter: a => localeFormatter('apply.method.type', a),
  },
  {
    dataField: 'decision_deadline_date',
    text: 'Дата планового закрытия',
    formatter: dateFormatter,
    headerClassName: 'created-at',
  },
  {
    dataField: 'status',
    text: 'Статус обращения',
    headerClassName: 'status-column',
    formatter: a => statusFormatter(a),
  },
  {
    dataField: 'updated_at',
    text: 'Дата установки статуса',
    headerClassName: 'created-at',
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'creator',
    text: 'Автор',
    headerClassName: 'user-column',
    formatter: userPositionFormatter,
  },
];

export const applicationAdditionalColumns = [
  {
    dataField: 'number_procedure',
    text: 'Номер процедуры',
    headerClassName: 'procedure-name-column',
    disableSort: true,
  },
  {
    dataField: 'indeficator',
    text: 'Идентификатор обращения',
    headerClassName: 'procedure-name-column',
    disableSort: true,
  },
  {
    dataField: 'applicant_type',
    text: 'Тип обращения',
    headerClassName: 'procedure-name-column',
    disableSort: true,
  },
  {
    dataField: 'fio',
    text: 'ФИО',
    headerClassName: 'procedure-name-column',
    disableSort: true,
  },
];
